import BasicDomain from "./BasicDomain";
import * as yup from 'yup';

export default class Taxonomy extends BasicDomain {
    static DEFAULTS = {
        subject: null,
        reproduction: null,
        nativityType: null,
        invasiveStatus: null,
        securityType: null,
        alternateIdentifiers: null,
        primaryName: null,
        parent: null,
        taxonomyType: null,
        taxonomyCategory: null,
        sRank: null,
        rigcn: null,
        rinhsStatus: null,
    }

    static VALIDATION_SCHEMA = yup.object({
        taxonomyCategory: yup.object().required('Taxonomy category is required'),
        subject: yup.object().when('taxonomyCategory', {
            is: (value) => value?.get('label') === 'Scientific Binomial',
            then: (schema) => schema.required('Subject is required'),
        }),
        reproduction: yup.object().when('taxonomyCategory', {
            is: (value) => value?.get('label') === 'Scientific Binomial',
            then: (schema) => schema.required('Reproduction status is required'),
        }),
        nativityType: yup.object().when('taxonomyCategory', {
            is: (value) => value?.get('label') === 'Scientific Binomial',
            then: (schema) => schema.required('Nativity type is required'),
        }),
        invasiveStatus: yup.object().when('taxonomyCategory', {
            is: (value) => value?.get('label') === 'Scientific Binomial',
            then: (schema) => schema.required('Invasive status is required'),
        }),
        securityType: yup.object().when('taxonomyCategory', {
            is: (value) => value?.get('label') === 'Scientific Binomial',
            then: (schema) => schema.required('Security type is required'),
        }),
    }).required();

    static CLASS_SUBJECT = 'Subject';
    static CLASS_REPRODUCTION = 'Reproduction';
    static CLASS_NATIVITY_TYPE = 'NativityType';
    static CLASS_INVASIVE_STATUS = 'InvasiveStatus';
    static CLASS_SECURITY_TYPE = 'SecurityType';
    static CLASS_TAXONOMY_SYSTEM = 'TaxonomySystem';

    static CLASSNAMES = {
        'subject': Taxonomy.CLASS_SUBJECT,
        'reproduction': Taxonomy.CLASS_REPRODUCTION,
        'nativityType': Taxonomy.CLASS_NATIVITY_TYPE,
        'invasiveStatus': Taxonomy.CLASS_INVASIVE_STATUS,
        'securityType': Taxonomy.CLASS_SECURITY_TYPE
    }

    constructor(props) {
        super('Taxonomy', props, Taxonomy.DEFAULTS);
    }

    isSavable = () => {
        if (!this.taxonomyCategory) return false;
        
        if (this.taxonomyCategory?.get('label') === 'Scientific Binomial') {
            return (
                this.subject && 
                this.reproduction && 
                this.nativityType && 
                this.invasiveStatus && 
                this.securityType
            );
        }
        
        return true;
    }

    inspect = () => {
        return Taxonomy.VALIDATION_SCHEMA.validate(this, { abortEarly: false });
    }

    // getByPath = (path = []) => {
    //     let value = this;
    //     try {
    //         for (const key of path) {
    //             if (!value) return '';
    //             value = value?.get(key);
    //         }
    //         return value;
    //     } catch (err) {
    //         console.error('Error getting value by path', path, err, value);
    //         return ''
    //     }
    // }
}

if (global.Parse.Object.registerSubclass) {
   global.Parse.Object.registerSubclass('Taxonomy', Taxonomy);
}